<template>
  <el-main>
    <banner></banner>
    <block-title title="线上场景"></block-title>
    <online></online>
    <block-title title="线下场景" class="offline-scene"></block-title>
    <offline></offline>
    <text-message-banner></text-message-banner>
    <direct-user-banner></direct-user-banner>
    <get-more></get-more>
  </el-main>
</template>

<script>
import Banner from '../../components/Banner'
import GetMore from '../../components/GetMore'
import Online from './components/Online'
import BlockTitle from '../../components/BlockTtitle'
import Offline from './components/Offline'
import TextMessageBanner from './components/TextMessageBanner'
import DirectUserBanner from './components/DirectUserBanner'

export default {
  name: 'Advantage',
  components: {
    Banner,
    GetMore,
    Online,
    BlockTitle,
    Offline,
    TextMessageBanner,
    DirectUserBanner
  }
}
</script>

<style scoped lang="stylus">
  .el-main
    padding: 20px 0
    .offline-scene
      padding-top: 68px
</style>



// WEBPACK FOOTER //
// src/pages/advantage/Advantage.vue